import { useEffect, useRef, useState } from "react";
import Select from "react-select";

const SmartSelect = ({ id, ...props }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  // Attach ref to wrapper div
  useEffect(() => {
    wrapperRef.current = document.getElementById(id) as HTMLDivElement;
  }, [id]);

  // Close on outside click (WITHOUT blocking search input)
  useEffect(() => {
    const handle = (e: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  return (
    <div id={id} style={{ width: "100%" }}>
      <Select
        {...props}
        isSearchable={true} // must be true for react-select search input

        // Menu control
        menuIsOpen={isOpen}
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => setIsOpen(false)}
        openMenuOnClick={true}
        openMenuOnFocus={true}

        // Prevent closing menu when typing inside search
        menuShouldScrollIntoView={false}
        controlShouldRenderValue={true}

        // styles={{
        //   control: (base) => ({
        //     ...base,
        //     minHeight: "44px",
        //     height: "44px",
        //     backgroundColor: "#0F172A",
        //     borderColor: "#334155",
        //     color: "white",
        //     "&:hover": { borderColor: "#3b82f6" },
        //   }),
        //   input: (base) => ({
        //     ...base,
        //     color: "white",
        //   }),
        //   singleValue: (base) => ({
        //     ...base,
        //     color: "white",
        //   }),
        //   menu: (base) => ({
        //     ...base,
        //     backgroundColor: "#0F172A",
        //     zIndex: 9999,
        //   }),
        //   option: (base, state) => ({
        //     ...base,
        //     backgroundColor: state.isFocused
        //       ? "#1e293b"
        //       : state.isSelected
        //       ? "#3b82f6"
        //       : "#0f172a",
        //     color: "white",
        //     cursor: "pointer",
        //   }),
        // }}
      />
    </div>
  );
};

export default SmartSelect;
